import { select, put, takeLatest, all } from 'redux-saga/effects';

import { api } from 'src/api';

import { getSearchParamsRequestId } from 'src/store/enqueue/selectors';
import {
  getMapDataAction,
  setActiveHotelDataAction,
  setHotelPopupDataAction,
} from './sagaActions';
import {
  resetPopupData,
  setActiveHotel,
  setMapData,
  setPopupData,
} from './slice';

import type {
  hotelMapDataResponse,
  setActiveHotelType,
  setPopupDataType,
} from './types';
import { isHotelCardOpenedSelector } from './selectors';

function* getMapData() {
  try {
    const requestId = yield select(getSearchParamsRequestId);

    const mapData: hotelMapDataResponse = yield api.getReferencesHotelMapData({
      request_id: requestId,
    });

    yield put(setMapData(mapData));
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Произошла ошибка', error);
  }
}

function* setActiveHotelData(action: setActiveHotelType) {
  try {
    const isHotelCardOpened = yield select(isHotelCardOpenedSelector);

    if (isHotelCardOpened) {
      yield put(resetPopupData());
    }

    yield put(setActiveHotel({ ...action.payload, zoomRequired: true }));
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Произошла ошибка', error);
  }
}

function* setHotelPopupData(action: setPopupDataType) {
  try {
    const isHotelCardOpened = yield select(isHotelCardOpenedSelector);

    if (isHotelCardOpened) {
      yield put(resetPopupData());
    }

    yield put(setPopupData(action.payload));
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Произошла ошибка', error);
  }
}

export default function* mapSaga() {
  yield all([
    yield takeLatest(getMapDataAction.type, getMapData),
    yield takeLatest(setActiveHotelDataAction.type, setActiveHotelData),
    yield takeLatest(setHotelPopupDataAction.type, setHotelPopupData),
  ]);
}
